import styled from 'styled-components';
import { color, font } from 'shared/utils/styles';
import { InputDebounced, Spinner, Icon } from '../../../../shared';
import { Button } from '../../shared/utils/styles';

export const ItemSearch = styled.div`
  padding: 25px 20px;
`;

export const SearchInputCont = styled.div`
  position: relative;
  padding-right: 30px;
  margin-bottom: 20px;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 0 0 32px;
  border: none;
  border-bottom: 2px solid ${color.primary};
  background: #fff;
  ${font.size(1)}
  &:focus,
    &:hover {
    box-shadow: none;
    border: none;
    border-bottom: 2px solid ${color.primary};
    background: #fff;
  }
`;

export const SearchInputDebounced = styled(InputDebounced)`
  height: 40px;
  input {
    padding: 0 0 0 32px;
    border: none;
    border-bottom: 2px solid ${color.primary};
    background: #fff;
    ${font.size(1)}
    &:focus,
    &:hover {
      box-shadow: none;
      border: none;
      border-bottom: 2px solid ${color.primary};
      background: #fff;
    }
  }
`;

export const SearchIcon = styled(Icon)`
  position: absolute;
  top: 8px;
  left: 0;
  color: ${color.textMedium};
`;

export const SearchSpinner = styled(Spinner)`
  position: absolute;
  top: 5px;
  right: 30px;
`;

export const BidActivityIcon = styled.i`
  color: ${(props) => props.color ?? 'black'};
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 10px;
  margin: 0px 0px;
  background-color: ${(props) => props.bgColor};
  border-radius: 5px;
  color: ${(props) => props.color};
  & i {
    font-size: 0.9em;
    padding-right: 5px;
    color: ${(props) => props.color};
  }
`;

export const ItemListContainer = styled.div`
  position: absolute;
  width: 325px;
  top: 175px;
  bottom: 50px;
  margin-left: -15px;
  display: flex;
  flex-direction: column;
`;

export const ItemList = styled.div`
  flex-grow: 1;
  min-height: 0;
  padding-left: 15px;
  overflow-y: auto;
`;

export const ItemData = styled.div`
  padding-left: 0px;
  padding-right: 0px;
`;

export const ItemTitle = styled.div`
  color: ${(props) => props.color};
  ${font.size(1)}
`;

export const ItemTypeId = styled.div`
  text-transform: uppercase;
  color: ${color.textMedium};
  ${font.size(1)}
`;

export const SectionTitle = styled.div`
  position: absolute;
  top: 155px;
  padding-bottom: 12px;
  text-transform: uppercase;
  color: ${color.textMedium};
  ${font.bold}
  ${font.size(1)}
`;

export const NoResults = styled.div`
  padding-top: 50px;
  text-align: center;
`;

export const NoResultsTitle = styled.div`
  padding-top: 30px;
  ${font.medium}
  ${font.size(1)}
`;

export const NoResultsTip = styled.div`
  padding-top: 10px;
  ${font.size(1)}
`;

export const FilterButton = styled(Button)`
  height: 2em;
  font-size: 0.8em;
  padding: 2px 4px;
  text-transform: none;
  font-weight: normal;
`;

export const FilterButtonContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-around;
  height: 60px;
  flex-wrap: wrap;
  margin-top: 20px;
  padding: 5px 0px;
`;
